function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/* eslint-disable */
import axios from 'axios';
import AxiosUtils from '../../utilities/axios-utils';
import ConfigurationManager from '../configuration-manager';
import CheckUtils from '../../utilities/check-utils';
import SessionStorageManager from '../session-storage-manager';
import { SSMKeys } from '../const';

/**
 * @memberOf module:wdh-feature-b2b
 */
var ApiClientCart = /*#__PURE__*/function () {
  function ApiClientCart(token) {
    _classCallCheck(this, ApiClientCart);
    this.token = token;
  }
  return _createClass(ApiClientCart, [{
    key: "initErrorHandling",
    value: function initErrorHandling(callback) {
      this.errorHandlingCallback = callback;
    }

    /**
     * Add a client order to the cart
     */
  }, {
    key: "addClientOrder",
    value: function addClientOrder(clientOrderId) {
      var _this = this;
      var promise = new Promise(function (resolve, reject) {
        axios.post('/api/cart/add-client-order', {
          clientOrderId: clientOrderId
        }, AxiosUtils.getConfig(ConfigurationManager.getShopServiceEndPoint(), _this.token)).then(function (response) {
          resolve(response.data);
        }).catch(function (err) {
          // Connection error
          reject(err);
          _this.errorHandlingCallback(err.response.data);
        });
      });
      return promise;
    }

    /**
    * Add products to the cart
    */
  }, {
    key: "addItems",
    value: function addItems(items) {
      var _this2 = this;
      var promise = new Promise(function (resolve, reject) {
        axios.post('/api/cart/add/', items, AxiosUtils.getConfig(ConfigurationManager.getShopServiceEndPoint(), _this2.token)).then(function () {
          resolve();
        }).catch(function (err) {
          reject(err);
          _this2.errorHandlingCallback(err.response.data);
        });
      });
      return promise;
    }

    /**
    * Gets the content of the cart
    */
  }, {
    key: "getCart",
    value: function getCart() {
      var _this3 = this;
      var isQuoteRequired = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var promise = new Promise(function (resolve, reject) {
        axios.get("/api/shop/cart?IsQuoteRequired=".concat(isQuoteRequired), AxiosUtils.getConfig(ConfigurationManager.getUSOrdersServiceEndPoint(), _this3.token)).then(function (response) {
          resolve(response.data);
        }).catch(function (err) {
          reject(err);
          _this3.errorHandlingCallback(err.response.data);
        });
      });
      return promise;
    }

    /**
    * Get cart details
    */
  }, {
    key: "getCartDetails",
    value: function getCartDetails() {
      var _this4 = this;
      var promise = new Promise(function (resolve, reject) {
        axios.get('/api/cart/details', AxiosUtils.getConfig(ConfigurationManager.getShopServiceEndPoint(), _this4.token)).then(function (response) {
          resolve(response.data);
        }).catch(function (err) {
          reject(err);
          _this4.errorHandlingCallback(err.response.data);
        });
      });
      return promise;
    }

    /**
    * Get products for a given client order
    */
  }, {
    key: "getClientOrderCartProducts",
    value: function getClientOrderCartProducts(clientOrderId) {
      var _this5 = this;
      var promise = new Promise(function (resolve, reject) {
        axios.get("/api/cart/get-client-order-cart-products?clientOrderId=".concat(clientOrderId), AxiosUtils.getConfig(ConfigurationManager.getShopServiceEndPoint(), _this5.token)).then(function (response) {
          resolve(response.data);
        }).catch(function (err) {
          reject(err);
          _this5.errorHandlingCallback(err.response.data);
        });
      });
      return promise;
    }

    /**
    * Get comments for the checkout
    */
  }, {
    key: "getComments",
    value: function getComments() {
      var _this6 = this;
      var promise = new Promise(function (resolve, reject) {
        axios.get('/api/cart/comments', AxiosUtils.getConfig(ConfigurationManager.getShopServiceEndPoint(), _this6.token)).then(function (response) {
          resolve(CheckUtils.isNullOrEmptyString(response.data.comments) ? '' : response.data.comments);
        }).catch(function (err) {
          reject(err);
          _this6.errorHandlingCallback(err.response.data);
        });
      });
      return promise;
    }

    /**
    * Get values for the checkout
    */
  }, {
    key: "getValue",
    value: function getValue() {
      var _this7 = this;
      var promise = new Promise(function (resolve, reject) {
        axios.get('/api/cart/value', AxiosUtils.getConfig(ConfigurationManager.getShopServiceEndPoint(), _this7.token)).then(function (response) {
          resolve(response.data);
        }).catch(function (err) {
          reject(err);
          _this7.errorHandlingCallback(err.response.data);
        });
      });
      return promise;
    }

    /**
    * Remove all client orders
    */
  }, {
    key: "removeClientOrders",
    value: function removeClientOrders() {
      var _this8 = this;
      var promise = new Promise(function (resolve, reject) {
        axios.post('/api/cart/remove-client-orders', null, AxiosUtils.getConfig(ConfigurationManager.getShopServiceEndPoint(), _this8.token)).then(function (response) {
          var result = {
            items: response.data.items
          };
          resolve(result);
          localStorage.removeItem('sendImpressionSeparate');
        }).catch(function (err) {
          reject(err);
          _this8.errorHandlingCallback(err.response.data);
        });
      });
      return promise;
    }

    /**
    * Remove a single item from the cart
    */
  }, {
    key: "removeItem",
    value: function removeItem(itemId) {
      var _this9 = this;
      var promise = new Promise(function (resolve, reject) {
        axios.post('/api/cart/remove/', "\"".concat(itemId, "\""), AxiosUtils.getConfig(ConfigurationManager.getShopServiceEndPoint(), _this9.token)).then(function (response) {
          resolve(response.data);
        }).catch(function (err) {
          reject(err);
          _this9.errorHandlingCallback(err.response.data);
        });
      });
      return promise;
    }

    /**
     * Get the cart quantity
     */
  }, {
    key: "count",
    value: function count() {
      var _this0 = this;
      var promise = new Promise(function (resolve, reject) {
        axios.get('api/shop/cart/count', AxiosUtils.getConfig(ConfigurationManager.getUSOrdersServiceEndPoint(), _this0.token)).then(function (response) {
          resolve(response.data);
        }).catch(function (err) {
          reject(err);
          _this0.errorHandlingCallback(err.response.data);
        });
      });
      return promise;
    }

    /**
     * Places the cart as an order and then clears cart.
     * Returns order id.
     */
  }, {
    key: "placeOrder",
    value: function placeOrder() {
      var _this1 = this;
      var poNumber = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
      var comments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
      var sendImpressionSeparate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";
      var promise = new Promise(function (resolve, reject) {
        axios.post('api/shop/cart/place-order', {
          poNumber: poNumber,
          comments: comments,
          sendImpressionSeparate: sendImpressionSeparate
        }, AxiosUtils.getConfig(ConfigurationManager.getUSOrdersServiceEndPoint(), _this1.token)).then(function (response) {
          resolve(response.data);
        }).catch(function (err) {
          reject(err);
          _this1.errorHandlingCallback(err.response.data);
        });
      });
      return promise;
    }

    /**
     * Gets the coupons for the specified item number.  If no item number, returns all coupons available.
     */
  }, {
    key: "getCoupons",
    value: function getCoupons() {
      var _this10 = this;
      var itemNumber = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
      var clearCache = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      return new Promise(function (resolve, reject) {
        if (!CheckUtils.isNullOrEmptyString(itemNumber) || clearCache || !SessionStorageManager.hasData(SSMKeys.allCoupons)) {
          var item = itemNumber !== "" ? "?itemNumber=".concat(itemNumber) : '';
          axios.get("api/shop/cart/coupon".concat(item), AxiosUtils.getConfig(ConfigurationManager.getUSOrdersServiceEndPoint(), _this10.token)).then(function (response) {
            if (itemNumber === "") {
              // only store all coupons
              SessionStorageManager.setData(SSMKeys.allCoupons, response.data, 'eod');
            }
            resolve(response.data);
          }).catch(function (err) {
            reject(err);
            _this10.errorHandlingCallback(err.response.data);
          });
        } else {
          resolve(SessionStorageManager.getData(SSMKeys.allCoupons).data);
        }
      });
    }

    /**
     * Check if Promotion/Coupon Applid
     */
  }, {
    key: "checkPromotionOrCouponApplied",
    value: function checkPromotionOrCouponApplied() {
      var _this11 = this;
      return new Promise(function (resolve, reject) {
        axios.get("api/shop/cart/is-coupon-promotion-applied", AxiosUtils.getConfig(ConfigurationManager.getUSOrdersServiceEndPoint(), _this11.token)).then(function (response) {
          resolve(response.data);
        }).catch(function (err) {
          reject(err);
          _this11.errorHandlingCallback(err.response.data);
        });
      });
    }

    /**
     * Check if Promotion/Coupon Applid
     */
  }, {
    key: "removeAppliedPromotionCoupon",
    value: function removeAppliedPromotionCoupon(billTo, sellTo) {
      var _this12 = this;
      return new Promise(function (resolve, reject) {
        axios.delete("api/shop/cart/".concat(billTo, "/").concat(sellTo, "/delete-all-promotion-coupon"), AxiosUtils.getConfig(ConfigurationManager.getUSOrdersServiceEndPoint(), _this12.token)).then(function (response) {
          resolve(response.data);
        }).catch(function (err) {
          reject(err);
          _this12.errorHandlingCallback(err.response.data);
        });
      });
    }

    /**
     * Validate PO number
     */
  }, {
    key: "validatePONumber",
    value: function validatePONumber(poNum) {
      var _this13 = this;
      return new Promise(function (resolve, reject) {
        axios.get("/api/shop/cart/validate-poNumber?poNumber=".concat(poNum), AxiosUtils.getConfig(ConfigurationManager.getUSOrdersServiceEndPoint(), _this13.token)).then(function (response) {
          resolve(response.data);
        }).catch(function (err) {
          reject(err);
          _this13.errorHandlingCallback(err.response.data);
        });
      });
    }

    /**
     * clears all orders from the cart.
     */
  }, {
    key: "deleteAll",
    value: function deleteAll() {
      var _this14 = this;
      return new Promise(function (resolve, reject) {
        axios.delete('api/shop/cart/delete-all', AxiosUtils.getConfig(ConfigurationManager.getUSOrdersServiceEndPoint(), _this14.token)).then(function (response) {
          resolve(response);
        }).catch(function (err) {
          console.log('errors', err);
          reject(err);
          console.log('response header', err);
          _this14.errorHandlingCallback(err.response.data);
        });
      });
    }
  }]);
}();
export default ApiClientCart;